module.exports = __webpack_public_path__ + "static/dr-castor-garaban-logos-7cd10ef17cd87271502e1bf182c59b99.svg";